import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=e04aa8ce&"
import script from "./ReportsTable.vue?vue&type=script&lang=js&"
export * from "./ReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e04aa8ce')) {
      api.createRecord('e04aa8ce', component.options)
    } else {
      api.reload('e04aa8ce', component.options)
    }
    module.hot.accept("./ReportsTable.vue?vue&type=template&id=e04aa8ce&", function () {
      api.rerender('e04aa8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research/Widgets/ReportsTable.vue"
export default component.exports